import React from 'react';
import MapTo from '@utils/mapto';

const SuccessMessage = ({ successBlock }) => {
  
  if (!successBlock || !Array.isArray(successBlock) || successBlock.length === 0) {
    return <div>No success message found</div>;
  }
  return (
    <>
      {successBlock.map((container) => {
        if (!container || !container.id) return null;
        
        return (
          <MapTo items={container} />
        );
      })}
    </>
  );
};

export default SuccessMessage;